import BaseService from "@/app/base/BaseService"
import managerApi from "@/app/base/CompanyApiService"
import {AUTH_URL} from "./enum"

export class AuthService extends BaseService {
    constructor(props) {
        super(props)
    }

    register(manager_data) {
        return managerApi.post(AUTH_URL.register, manager_data)
    }

    activeAccount(data) {
        return managerApi.post(AUTH_URL.activeAcount, data)
    }

    login(cer) {
        return managerApi.post(AUTH_URL.login, cer)
    }

    rePassword(cer) {
        if (!cer || !cer.email) return Promise.reject('no c-user data')
        return managerApi.post(AUTH_URL.re_password, cer)
    }

    logout() {
        return managerApi.get(AUTH_URL.logout)
    }

    editProfile(data) {
        return managerApi.post(AUTH_URL.editProfile, data)
    }

    detailProfile(data) {
        return managerApi.post(AUTH_URL.detailProfile, data)
    }

    changeEmail(data) {
        return managerApi.post(AUTH_URL.changeEmail, data)
    }

    forgetPassword(data) {
        return managerApi.post(AUTH_URL.forgetPassword, data)
    }

    changePassword(data) {
        return managerApi.post(AUTH_URL.changePassword, data)
    }

    checkTokenTime(data){
        return managerApi.post(AUTH_URL.checkTokenTime, data)
    }
}

const authService = new AuthService()

export default authService
